// import node module libraries
import { useEffect, useState } from 'react';
import { Alert, Col, Row, Container } from 'react-bootstrap';
import axios from 'axios';

// Import authentication components
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';

// import custom components
import GKAccordionBox from 'components/marketing/common/accordions/GKAccordionBox';

// Import Loading Animation
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

/*
// import data files
import {
	MostAskedFAQs,
	GeneralInquiriesFAQs,
	SupportFAQs
} from 'data/marketing/help-center/HelpCenterFAQsData';
*/

const AllFAQsList = () => {
	const [MostAskedFAQs, setMostAskedFAQs] = useState([]);
	const [GeneralFAQs, setGeneralFAQs] = useState([]);
	const [SupportFAQs, setSupportFAQs] = useState([]);
	const [isLoadingMostAskedFAQs, setIsLoadingMostAskedFAQs] = useState(true);
	const [isLoadingGeneralFAQs, setIsLoadingGeneralFAQs] = useState(true);
	const [isLoadingSupportFAQs, setIsLoadingSupportFAQs] = useState(true);

	const authHeader = useAuthHeader();
	// fetch data from api
	const options = {
		params: {

		},
		headers: {
			Authorization: authHeader,
			Accept: 'application/json'
		}
	};

	const getData = async () => {
		setIsLoadingMostAskedFAQs(true);
		setIsLoadingGeneralFAQs(true);
		setIsLoadingSupportFAQs(true);

		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		await axios.get(`${baseURL}/public/faqs?faq_categories=mostasked`, options)
			.then(response => {
				const responseData = response.data.data; // Extract the data from the response
				setMostAskedFAQs(
					responseData
						? responseData.map(item => ({
							id: item.id,
							title: item.faq_title,
							content: item.faq_content
						}))
						: []
				); // Map the data to match the expected keys
				setIsLoadingMostAskedFAQs(false);
			})
			.catch((error) => {
				setIsLoadingMostAskedFAQs(false);
			});

		await axios.get(`${baseURL}/public/faqs?faq_categories=general`, options)
			.then(response => {
				const responseData = response.data.data; // Extract the data from the response
				setGeneralFAQs(
					responseData
						? responseData.map(item => ({
							id: item.id,
							title: item.faq_title,
							content: item.faq_content
						}))
						: []
				); // Map the data to match the expected keys
				setIsLoadingGeneralFAQs(false);
			})
			.catch((error) => {
				setIsLoadingGeneralFAQs(false);
			});

		await axios.get(`${baseURL}/public/faqs?faq_categories=support`, options)
			.then(response => {
				const responseData = response.data.data; // Extract the data from the response
				setSupportFAQs(
					responseData
						? responseData.map(item => ({
							id: item.id,
							title: item.faq_title,
							content: item.faq_content
						}))
						: []
				); // Map the data to match the expected keys
				setIsLoadingSupportFAQs(false);
			})
			.catch((error) => {
				setIsLoadingSupportFAQs(false);
			});
	}

	useEffect(() => {
		getData();
	}, []);

	return (
		<section className="py-10">
			<Container>
				{/* most asked faqs accordion  */}
				<Row>
					<Col md={{ offset: 2, span: 8 }} xs={12}>
						<div className="mb-4">
							<h2 className="mb-0 fw-semi-bold">Am meisten gefragt</h2>
						</div>
						{isLoadingMostAskedFAQs || MostAskedFAQs && MostAskedFAQs.length == 0 ? (
							<Skeleton height="40px" count={8} />
						) : (
							MostAskedFAQs && MostAskedFAQs.length > 0 && (
								<GKAccordionBox accordionItems={MostAskedFAQs} itemClass="px-0" />
							)
						)}
					</Col>
				</Row>

				{/* general faqs accordion  */}
				<Row>
					<Col md={{ offset: 2, span: 8 }} xs={12}>
						<div className="mb-4 mt-6">
							<h2 className="mb-0 fw-semi-bold">Allgemeine Fragen</h2>
						</div>
						{isLoadingGeneralFAQs || GeneralFAQs && GeneralFAQs.length == 0 ? (
							<Skeleton height="40px" count={8} />
						) : (
							GeneralFAQs && GeneralFAQs.length > 0 && (
								<GKAccordionBox accordionItems={GeneralFAQs} itemClass="px-0" />
							)
						)}
					</Col>
				</Row>

				{/* support faqs accordion  */}
				<Row>
					<Col md={{ offset: 2, span: 8 }} xs={12}>
						<div className="mb-4 mt-6">
							<h2 className="mb-0 fw-semi-bold">Support</h2>
						</div>
						{isLoadingSupportFAQs || SupportFAQs && SupportFAQs.length == 0 ? (
							<Skeleton height="40px" count={8} />
						) : (
							SupportFAQs && SupportFAQs.length > 0 && (
								<GKAccordionBox accordionItems={SupportFAQs} itemClass="px-0" />
							)
						)}
					</Col>
				</Row>
			</Container>
		</section>
	);
};
export default AllFAQsList;
